<template>
    <!-- 牌匾服务说明：-显示弹窗 -->
  <div class="lq_popup_box">
    <div class="lq_popup_mask" @click="serviceDescriptionCloseFun"></div>
    <div class="lq_popup_min_box flex-align-cen">
        <img
            class="close"
            @click="serviceDescriptionCloseFun"
            src="@/assets/icon/close-icon.svg"
            alt=""
        />
        <div class="lq_popup_title">牌匾服务说明</div>
        <div class="lq_popup_content scrollbar-list">
        <p class="content_p">        
            为响应党和国家“守信激励、失信惩戒”号召，促进中小企业（含个体经营者，以下统称“经营主体或主体”）健康发展，营造良好的营商环境，北京优信立信企业信用评估中心（以下简称“公司”）负责运营的全国信用信息大数据试点平台，向经营主体推出以守信为前提的优信立信计划（牌匾）服务（以下简称“优信立信计划服务”）。为维护各方利益，现就优信立信计划服务的有关事项进行告知、说明。经营主体缴纳优信立信计划服务相关费用后，意味着已阅读本说明并同意依照本说明办理业务、处理纠纷。
            <br />
            一、 加入优信立信服务的条件
            <br />
            1、非失信被执行人、未发现重大违法行为、不存在经营异常、重大负面舆情等；
            <br />
            2、自愿签署守信承诺书；
            <br />
            3、遵守本说明约定并按本说明履行责任和义务。
            <br />
            二、优信立信牌匾服务说明
            <br />
            1、优信立信计划服务包含立信牌匾、守信承诺牌匾、行业牌匾及其他荣誉牌匾等服务，经营主体可按需购买其中一种或多种牌匾服务。
            <br />
            2、制作并寄送牌匾，获得该牌匾的主体意味着在申请时点不存在严重失信行为、签署了守信承诺书、愿意接受社会和消费者的监督、愿意为营商环境改善贡献力量；
            <br />
            3、开通扫描二维码查询主体信用，上传消费者意见等功能；
            <br />
            4、对牌匾主体信用进行动态监测。有严重失信行为的，包括但不限于失信被执行、因重大违法行为被行政处罚、重大税务违法等，公司将终止服务并不退还服务费用；
            <br />
            5、付费主体可请求对其信用状况进行检测，并对其进行信用评分；
            <br />
            6、激活付费主体信用档案，生成信用档案落地页且可查询、可维护、可分享；
            <br />
            7、付费主体可对交易对手、关注对象的风险状况进行实时查询。
            <br />
            三、优信立信牌匾服务收费说明
            <br />
            优信立信计划服务按一年180元收费（包括木质牌匾和上述“二”所列服务）。
            <br />
            公司还提供金属牌匾供选择，选择金属牌匾的，须再支付100元费用。
            <br />
            四、其他有关说明
            <br />
            1、经营主体购买优信立信计划服务须进行实名核验，须按要求提交完整、真实的资料且履行相关程序。公司将在三个工作日内完成核验，并在核验完成后十个工作日进行牌匾的制作和邮寄。如因不可抗力或其它客观原因无法完成的，公司将全额退还服务费用；
            <br />
            2、在办理优信立信计划服务业务过程中，经营主体提交的资料及填写的相关个人信息，公司仅限用于办理业务及与主体的业务联系、日常服务、快递、售后服务等；公司将采取严格的保密措施，未经主体同意，不向任何第三方提供；
            <br />
            3、为了实现订制内容的定点推送，您授权我们就注册时的信息（如电子邮件、电话号码等）在授权范围内进行合理适用。我们将根据您的订阅：1、向您提供所需要的产品或服务（如，产品推送）；2、就您的要求向您提供咨询服务； 3、向您提供我们认为您可能会感兴趣的产品或服务；4、为提升我们的服务，联系您进行调研；5、进行数据分析；6、 经营、评估和完善我们的业务（包括开发新产品和服务；管理我们的通信；判断我们的销售、营销和广告效果； 分析和强化我们的产品、服务和网站）； 7、在事先获得您同意的情况下，向您指定的联系人发送信息；如您不需要上述订制服务内容，您可再首次获取内容后选择退订。
            <br />
            4、付费用户与公司产生纠纷的，双方应当友好协商解决，协商不成的，可向北京市昌平区人民法院提起诉讼。双方同意，不以任何方式侵害对方的商誉、名誉等，否则，任何一方均可追究对方的法律责任；
            <br />
            5、主体支付优信立信计划服务费或实际使用本服务后，意味着主体已全面、仔细阅读本说明并同意将本说明作为约束双方的法律文件，双方均有义务依据本说明履行相关责任和义务。
            <br /></p>				
    </div>
        
    </div>			
  </div>


</template>

<script>
export default {
    name: "serviceDescription",
    data() {
        return {
           
        };
    },
    created() {
    },
    methods: {
       //牌匾服务说明：弹窗关闭
        serviceDescriptionCloseFun() {
            this.$emit("serviceDescriptionClose");
        },
    },
};
</script>

<style lang="less" scoped>
.lq_popup_box{
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  .lq_popup_mask{
      width: 100vw;
      height: 100vh;
      background-color: rgba(0, 0, 0, 0.6);
      position: absolute;
      left: 0;top: 0;
      z-index: 3;
  }
  .lq_popup_min_box{
      width: 320px;
      position: absolute;
      left: 50%;top: 50%;
      transform: translateX(-50%) translateY(-50%);
      z-index: 9;
      flex-direction: column;
      padding: 20px 15px;
      background-color: #ffffff;
      border-radius: 10px;
      box-sizing: border-box;
      .close {
            position: absolute;
            top: -20px;
            right: -20px;
            width: 24px;
            height: 24px;
            display: block;
        }
      .lq_popup_title{
        font-size: 17px;
        color: #222222;
        text-align: center;
        font-weight: 500;
        line-height: 24px;
      }
      .lq_popup_content{
        width: 100%;
        max-height: 60vh;
        overflow-y: auto;
        padding-top: 6px;         
        .content_p{
            margin: 0;padding: 0;
          font-size: 15px;
          color: rgba(0, 0, 0, 0.5);
          line-height: 24px;
        }          
    }  
    .scrollbar-list::-webkit-scrollbar {
        width:0;
    }  
  }
}
</style>
